(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.chLiveSearchInstalledV2) return;
  window.chLiveSearchInstalledV2 = true;
  const selector = '[data-live-search] .ch-search__input';
  let owner = null, input = null, panel = null, controller = null, timer = null, sequence = 0;
  const cache = new Map();
  const desktop = () => matchMedia('(min-width:750px)').matches;
  const close = () => {
    clearTimeout(timer); sequence++;
    if(controller) controller.abort();
    if(panel) panel.hidden = true;
    if(input) input.setAttribute('aria-expanded','false');
  };
  const arrows = () => {
    const track = panel?.querySelector('.ch-search-results__track');
    if(!track) return;
    const prev = panel.querySelector('[data-search-direction="-1"]');
    const next = panel.querySelector('[data-search-direction="1"]');
    if(prev) prev.disabled = track.scrollLeft <= 2;
    if(next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  const position = () => {
    if(!owner || !panel || panel.hidden) return;
    if(!desktop() || !owner.isConnected) { close(); return; }
    const rect = owner.querySelector('.ch-search__form').getBoundingClientRect();
    if(rect.bottom < 0 || rect.top > innerHeight) { close(); return; }
    const top = Math.max(8, rect.bottom + 8);
    panel.style.top = top + 'px';
    panel.style.setProperty('--ch-search-top', top + 'px');
  };
  const activate = field => {
    if(input !== field) close();
    input = field; owner = field.closest('[data-live-search]');
    if(!panel) {
      panel = document.createElement('section'); panel.id = 'CenturyLiveSearchPanelV2';
      panel.className = 'ch-search__panel'; panel.hidden = true;
      panel.setAttribute('aria-label','Sugerencias de productos');
      panel.style.zIndex = '2147482000'; document.body.append(panel);
      panel.addEventListener('click',event => {
        const button = event.target.closest('[data-search-direction]');
        const track = panel.querySelector('.ch-search-results__track');
        if(!button || !track) return;
        track.scrollBy({left:Number(button.dataset.searchDirection)*((track.firstElementChild?.getBoundingClientRect().width || 204)+16),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      });
    }
    field.setAttribute('aria-controls',panel.id);
    field.setAttribute('aria-expanded',String(!panel.hidden));
  };
  const show = () => {
    if(!desktop()) return;
    panel.hidden = false; input.setAttribute('aria-expanded','true'); position();
  };
  const display = fragment => {
    panel.replaceChildren(fragment);
    const track = panel.querySelector('.ch-search-results__track');
    if(track) track.addEventListener('scroll',arrows,{passive:true});
    show(); requestAnimationFrame(arrows);
  };
  const getFragment = async (url,signal) => {
    const response = await fetch(url,{signal,credentials:'same-origin',headers:{'Accept':'text/html'}});
    if(!response.ok) throw new Error('Search request failed');
    const html = await response.text();
    const fragment = new DOMParser().parseFromString(html,'text/html').querySelector('[data-search-results]');
    if(!fragment) throw new Error('Search fragment unavailable');
    return fragment;
  };
  const load = async (term,version) => {
    if(version !== sequence || !desktop()) return;
    const field = input;
    if(cache.has(term)) { display(cache.get(term).cloneNode(true)); return; }
    controller = new AbortController();
    const signal = controller.signal;
    const loading = document.createElement('p'); loading.setAttribute('role','status'); loading.textContent = 'Buscando productos…';
    display(loading);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(owner.dataset.endpoint || root+'search/suggest',location.origin);
      url.searchParams.set('q',term); url.searchParams.set('resources[type]','product');
      url.searchParams.set('resources[limit]','10'); url.searchParams.set('section_id',owner.dataset.section);
      let fragment;
      try { fragment = await getFragment(url,signal); }
      catch(error) {
        if(error.name==='AbortError') throw error;
        const fallback = new URL(owner.querySelector('form').action,location.origin);
        fallback.searchParams.set('q',term); fallback.searchParams.set('type','product');
        fallback.searchParams.set('section_id',owner.dataset.section);
        fragment = await getFragment(fallback,signal);
      }
      if(version !== sequence || field !== input || field.value.trim() !== term || !field.isConnected) return;
      cache.set(term,fragment.cloneNode(true)); if(cache.size>12) cache.delete(cache.keys().next().value);
      display(fragment);
    } catch(error) {
      if(error.name==='AbortError' || version !== sequence) return;
      const container = document.createElement('div');
      const message = document.createElement('p'); message.setAttribute('role','status');
      message.textContent = 'No pudimos cargar las sugerencias en este momento.';
      const link = document.createElement('a');
      const url = new URL(owner.querySelector('form').action,location.origin); url.searchParams.set('q',term); url.searchParams.set('type','product');
      link.href = url.href; link.textContent = 'Ver todos los resultados →';
      container.append(message,link); display(container);
    }
  };
  const queue = field => {
    activate(field); close();
    const term = field.value.trim();
    if(term.length<2 || !desktop()) return;
    const version = sequence;
    timer = setTimeout(()=>load(term,version),220);
  };
  document.addEventListener('input',event => { if(event.target.matches?.(selector)) queue(event.target); });
  document.addEventListener('focusin',event => {
    if(event.target.matches?.(selector)) { queue(event.target); return; }
    if(panel && !panel.hidden && !panel.contains(event.target) && !owner?.contains(event.target)) close();
  });
  document.addEventListener('pointerdown',event => {
    if(panel && !panel.hidden && !panel.contains(event.target) && !owner?.contains(event.target)) close();
  });
  document.addEventListener('keydown',event => {
    if(event.key==='Escape' && panel && !panel.hidden) {
      const field = input;
      if(field && document.activeElement !== field) field.focus({preventScroll:true});
      close();
    }
  });
  document.addEventListener('submit',event => { if(owner?.contains(event.target)) close(); });
  window.addEventListener('resize',()=>{position();arrows();});
  window.addEventListener('scroll',position,{passive:true});
  document.addEventListener('shopify:section:unload',()=>{ if(owner && !owner.isConnected) close(); });
})();
  } catch(e) { console.error(e); }
})();

})();
